import React from "react";

import { Search, KeyboardArrowDown } from "components/Icons";
import Button from "components/Button";
import Input from "components/Input";

import "./style.scss";

interface IProps {
  value?: string | number;
  placeholder?: string;
  onChange?: (any?) => void;
  active?: boolean;
  toggleFilter?: () => void;
  advancedSearch?: JSX.Element;
}

class SearchInput extends React.Component<IProps> {
  public render() {
    const {
      value,
      placeholder = "",
      onChange,
      toggleFilter,
      active = false,
      advancedSearch
    } = this.props;

    return (
      <div id="cnb-search-input">
        <div
          className="main-bar"
          style={{ borderBottom: active ? "none" : "1px solid #d4dde1" }}
        >
          <div className="search-bar">
            <Search />
            <Input
              type="search"
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              disabled={active}
            />
          </div>
          {advancedSearch && (
            <Button
              kind={active ? "dark" : "light"}
              icon={<KeyboardArrowDown />}
              className="reversed open-filter"
              onClick={toggleFilter}
            >
              ADVANCED_SEARCH
            </Button>
          )}
        </div>
        {active && advancedSearch}
      </div>
    );
  }
}

export default SearchInput;
